import React, { useEffect, useRef, useState } from "react";
import "react-phone-input-2/lib/style.css";
import BreadCrum from "../../components/common/BreadCrum";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/routes-constant";
import Input from "../../components/common/input";
import DropDown from "../../components/common/dropdown";
import {
  ErrorMsg,
  getCurrencySymbol,
  handleFormInput,
  hasValidationErrors,
} from "../../utils/form-utils";
import Button from "../../components/common/button";
import { useSelector } from "react-redux";
import {
  decryptAEStoJSON,
  toastEmitter,
  validateRegex,
} from "../../utils/utilities";
import {
  doctoraddByClinic,
  doctorAllDoctorProfile,
  getCountrybytype,
  getDoctorEmailId,
  getSpecializationList,
} from "../../hooks/services/api-services";
import { API_RESPONSE } from "../../utils/app-constants";
import { EmailRegex } from "../../utils/regexValidation";
import { EYE_CLOSE, EYE_OPEN } from "../../utils/aap-image-constant";
import Modal from "../../components/common/Model";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../utils/url-constants";
import NumberInput from "../../components/common/number-input";

const AddDoctor = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();

  const [formError, setFormError] = useState({});
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const currencySign = getCurrencySymbol(userData?.country);

  const addbuttonClick = useRef();
  const location = useLocation();
  const [verifiedEmail, setverifiedEmail] = useState(false);
  const [isNewDoctor, setIsNewDoctor] = useState(true);
  const [isPasswordFieldShow, setIsPasswordFieldShow] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isPwdVisible, setIsPwdVisible] = useState("password");
  const [specializationList, setSpecializationList] = useState([]);
  let doctorType = location?.state?.pageType;
  const [profileList, setProfileList] = useState([]);
  const [isDoctorDataPresent, setIsDocttorDataPresent] = useState([]);
  const [selectedOtherProfile, setSelectedOtherProfile] = useState(false);
  const [selectedOtherSpecialty, setSelectedOtherSpecialty] = useState(false);

  const adminShare = Number(userData?.adminPercentage || 0);
  const remainingShare = 100 - adminShare;

  const [modalContent, setModalContent] = useState({
    heading: "",
    paragraph: "",
    paragraphclassName: "",
  });
  const [addDoctor, setAddDoctor] = useState({
    clinicId: 0,
    id: 0,
    firstName: "",
    lastName: "",
    password: "",
    email: "",
    code: "",
    mobileNo: "",
    profile: "",
    cv: "",
    description: "",
    image: "",
    specialization: "",
    country: "",
    address: "",
    experience: "",
    language: i18n.language,
    fees: "",
    gender: "",
    clinicFees: "",
    dateOfBirth: "",
    knowLanguages: [],
    mrnDoc: "",
    mrnImage: "",
    sector: "",
    languageType: i18n.language,
    doctorClinicProfileCompleted: false,
    city: "",
    clinicShare: "",
    doctorShare: ""
  });
  const [countrynumber, setCountrynumber] = useState([]); // list of countries
  const [selectedCountry, setSelectedCountry] = useState(null); // country being used for phone input
  const handleClearPayload = () => {
    setAddDoctor({
      clinicId: userData?.id,
      id: 0,
      firstName: "",
      lastName: "",
      password: "",
      email: "",
      code: "",
      mobileNo: "",
      profile: "",
      cv: "",
      description: "",
      image: "",
      specialization: "",
      country: "",
      address: "",
      experience: "",
      language: "",
      fees: "",
      gender: "",
      clinicFees: "",
      dateOfBirth: "",
      knowLanguages: [],
      mrnDoc: "",
      mrnImage: "",
      sector: "",
      languageType: i18n.language,
      doctorClinicProfileCompleted: false,
      city: "",
      clinicShare: "",
      doctorShare: ""
    });
  };


  useEffect(() => {
    const selectedCountryName =
      isDoctorDataPresent?.length === 0
        ? userData?.country
        : isDoctorDataPresent?.country;
    const selectedCity =
      isDoctorDataPresent?.length === 0
        ? userData?.city
        : isDoctorDataPresent?.city;

    setAddDoctor((prev) => ({
      ...prev,
      country: selectedCountryName,
      city: selectedCity,
      code:
        isDoctorDataPresent?.length === 0
          ? userData?.code
          : isDoctorDataPresent?.code,
      clinicId: userData?.id,
      language: userData?.languageType,
      languageType: i18n.language,
      doctorClinicProfileCompleted: false
    }));

    const found = countrynumber?.find(
      (item) => item?.name === selectedCountryName
    );
    if (found) {
      setSelectedCountry(found);
    }
  }, [
    userData?.id,
    userData?.country,
    userData?.code,
    userData?.languageType,
    isDoctorDataPresent,
    userData?.city,
    countrynumber,
  ]);

  // doctor verified  if doctor is individual than get data and register and if doctor in not individual register than register
  const getDoctorbyEmail = async (e) => {
    e.preventDefault();
    if (addDoctor?.email?.trim() === "") {
      return toastEmitter("error", "Email is mandatory!");
    }
    if (!validateRegex(addDoctor?.email, EmailRegex)) {
      return toastEmitter("error", "Email is invalid!");
    }
    setIsLoading(true);
    try {
      const response = await getDoctorEmailId(addDoctor?.email);
      if (response.data?.status === 400) {
        setModalContent({
          heading: t("Cannot Add Doctor"),
          paragraph: response?.data?.message,
          paragraphclassName: "color-red-bold",
        });
        addbuttonClick?.current?.click();
        setAddDoctor({
          ...addDoctor,
          email: "",
        });
        setIsLoading(false);
        setIsPasswordFieldShow(true);
        setIsDocttorDataPresent([]);
        return;
      }
      if (response?.data?.status !== 200) {
        setverifiedEmail(true);
        setIsLoading(false);
        setIsPasswordFieldShow(true);
        setIsNewDoctor(false);
        setIsDocttorDataPresent([]);
        return;
      }
      if (response?.data?.status === 200) {
        toastEmitter("success", "Doctor profile present please add doctor");
        let res = response?.data?.data;
        setIsDocttorDataPresent(response?.data?.data);
        setAddDoctor({
          ...addDoctor,
          id: res?.id,
          firstName: res?.firstName,
          lastName: res?.lastName,
          password: res?.lastName,
          email: res?.email,
          code: res?.code,
          mobileNo: res?.mobileNo,
          profile: res?.profile,
          cv: res?.cv,
          description: res?.description,
          image: res?.image,
          specialization: res.specialization,
          country: res?.country,
          city: res?.city,
          address: res?.address,
          experience: res?.experience,
          language: res?.language,
          fees: res?.fees,
          gender: res?.gender,
          clinicFees: res?.clinicFees,
          dateOfBirth: res?.dateOfBirth || "",
          knowLanguages: res?.knowLanguages || [],
          mrnDoc: res?.mrnDoc || "",
          mrnImage: res?.mrnImage || "",
          sector: res?.sector || "",
          languageType: res?.languageType || "",
          doctorClinicProfileCompleted: res?.doctorClinicProfileCompleted,
          clinicShare: res?.clinicShare,
          doctorShare: res.doctorShare
        });
        setverifiedEmail(true);
        setIsPasswordFieldShow(false);
        setIsNewDoctor(true);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSubmit = async (e) => {

    e.preventDefault();
    console.log("Form payload:", addDoctor);
    console.log("Selected Specialization:", addDoctor?.specialization);
    console.log("Selected Profile:", addDoctor?.profile);
    if (!addDoctor?.firstName?.trim())
      return toastEmitter("error", "First Name is mandatory!");
    if (!addDoctor?.lastName?.trim())
      return toastEmitter("error", "Last Name is mandatory!");
    if (!addDoctor?.mobileNo?.trim())
      return toastEmitter("error", "Mobile No. is mandatory!");
    if (!addDoctor?.email?.trim())
      return toastEmitter("error", "Email is mandatory!");
    if (isPasswordFieldShow && !addDoctor?.password?.trim()) {
      return toastEmitter("error", "Password is mandatory!");
    }
    if (!addDoctor?.gender)
      return toastEmitter("error", "Please select a gender");
    if (!addDoctor?.specialization)
      return toastEmitter("error", "Please select a specialization");
    if (!addDoctor?.profile)
      return toastEmitter("error", "Please select a profile");
    if (!addDoctor?.clinicFees)
      return toastEmitter("error", "Clinic fees is mandatory!");
    if (addDoctor?.otherSpecialty?.trim() === "") {

      return toastEmitter("error", "Enter Your Specialization");
    }
    if (addDoctor?.otherProfile?.trim() === "") {
      return toastEmitter("error", "Enter Your Profile");
    }
if (addDoctor?.clinicShare === "" || addDoctor?.clinicShare === null) {
  return toastEmitter("error", "Enter Your Clinic share");
}

if (addDoctor?.doctorShare === "" || addDoctor?.doctorShare === null) {
  return toastEmitter("error", "Enter Your Doctor share");
}

    if (Number(addDoctor.clinicShare) + Number(addDoctor.doctorShare) !== remainingShare) {
      return toastEmitter(
        "error",
        `Clinic + Doctor share must equal ${remainingShare}%`
      );
    }

    if (hasValidationErrors(formError)) {
      toastEmitter("error", "Please correct the errors before submitting.");
      return;
    }
    setIsLoading(true);
    try {
      const response = await doctoraddByClinic(addDoctor);
      if (response?.data?.status !== 200) {
        setModalContent({
          heading: t("Cannot Add Doctor"),
          paragraph: response?.data?.message,
          paragraphclassName: "color-red-bold",
        });
        addbuttonClick?.current?.click();
        setAddDoctor({
          ...addDoctor,
          email: "",
        });
        setverifiedEmail(false);
        setIsLoading(false);
        handleClearPayload();
        return;
      }

      if (response?.data?.status === 200) {
        setverifiedEmail(false);
        handleClearPayload();
        setModalContent({
          heading: "Doctor Added Successfully",
          paragraph: response?.data?.message,
          paragraphclassName: "text-success",
        });
        addbuttonClick?.current?.click();
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      return setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleModalClose = () => {
    navigate(ROUTES.DOCTOR);
  };

  // fetch specialization and doctor profile list
  const getDoctorProfileList = async (language) => {
    try {
      const response = await doctorAllDoctorProfile(language);
      if (response?.data?.status === 200) {
        const formattedList = response?.data?.data?.map((item) => ({
          label: item,
          value: item,
        }))
          .sort((a, b) => a.label.localeCompare(b.label));

        setProfileList(formattedList);
      } else {
        toastEmitter("error", "Failed to fetch Profile List");
      }
    } catch (error) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchSpecializations = async (language) => {
    try {
      const response = await getSpecializationList(language);
      if (response?.data?.status === 200) {
        const formattedList = response?.data?.data?.map((item) => ({
          value: item?.specializationName,
          label: item?.specializationName,
        }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setSpecializationList(formattedList);
      } else {
        toastEmitter("error", "Failed to fetch specializations");
      }
    } catch (error) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setIsLoading(false);
    }
  };

  const getCountrybylanguage = async (language) => {
    try {
      const response = await getCountrybytype(language);
      if (response?.data?.status === 200) {
        const formattedList = response?.data?.data?.map((item) => ({
          label: `${item?.name} (${item?.code})`,
          value: item?.id,
          code: item?.code,
          logo: item?.logo,
          name: item?.name,
        }));
        setCountrynumber(formattedList);
      } else {
        toastEmitter("error", "Failed to fetch Profile List");
      }
    } catch (error) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSpecializations(i18n.language);
    getDoctorProfileList(i18n.language);
    getCountrybylanguage(i18n.language);
  }, [i18n.language]);
  // static gender data
  const genderList = [
    { id: 1, label: "Male" },
    { id: 2, label: "Female" },
    { id: 3, label: "Other" },
  ];

  const handlePhoneChange = (code, value) => {
    const cleanedValue = value.replace(/\D/g, '').slice(0, 15);

    setAddDoctor((prev) => ({
      ...prev,
      code: code,
      mobileNo: cleanedValue,
    }));
  };
  useEffect(() => {
    if (!addDoctor.specialization || !specializationList.length) return;
    // Check if specialization is in list
    const foundSpec = specializationList.find(
      (item) => item.value === addDoctor.specialization
    );
    setSelectedOtherSpecialty(!foundSpec); // true if NOT found → show input

  }, [addDoctor.specialization, specializationList]);

  useEffect(() => {
    if (!addDoctor.profile || !profileList.length) return;
    // Check if profile is in list
    const foundProfile = profileList.find(
      (item) => item.value === addDoctor.profile
    );
    setSelectedOtherProfile(!foundProfile); // true if NOT found → show input

  }, [addDoctor.profile, profileList]);

  return (
    <div className="main_datatable my-lg-3 my-1">
      <BreadCrum
        firstData={t("Doctor Management")}
        iconshow1={true}
        secondData={t("Add Doctor")}
        onFirstDataClick={() => navigate(ROUTES.DOCTOR)}
      />
      <form onSubmit={handleSubmit}>
        <div className="add_doctor card p-3 border border-radius_input mb-3">
          <h5 className="mb-2 fw-600 sec-heading">{t("Basic Informations")}</h5>
          <div className="row">
            <div className="col-md-12 mb-2">
              <Input
                className="border-radius_input"
                type="text"
                value={addDoctor.email}
                name="email"
                placeHolder={t("Enter email")}
                handleChange={(e) =>
                  setAddDoctor(
                    handleFormInput(e, addDoctor, formError, setFormError)
                  )
                }
                error={formError?.email}
                labelName="Email"
                disabled={verifiedEmail}
              />
              <ErrorMsg error={formError?.email} />
            </div>
            {verifiedEmail && (
              <>
                <div className="col-md-6 mb-2">
                  <Input
                    className="border-radius_input"
                    type="text"
                    value={addDoctor?.firstName}
                    name="firstName"
                    placeHolder="Enter first name"
                    handleChange={(e) =>
                      setAddDoctor(
                        handleFormInput(e, addDoctor, formError, setFormError)
                      )
                    }
                    error={formError?.firstName}
                    labelName="First Name"
                    disabled={isNewDoctor}
                  />
                  <ErrorMsg error={formError?.firstName} />
                </div>
                <div className="col-md-6 mb-2">
                  <Input
                    className="border-radius_input"
                    type="text"
                    value={addDoctor?.lastName}
                    name="lastName"
                    placeHolder="Enter last name"
                    handleChange={(e) =>
                      setAddDoctor(
                        handleFormInput(e, addDoctor, formError, setFormError)
                      )
                    }
                    error={formError?.lastName}
                    labelName="Last Name"
                    disabled={isNewDoctor}
                  />
                  <ErrorMsg error={formError?.lastName} />
                </div>
                <div className="col-md-6 mb-2">
                  <Input
                    className="border-radius_input"
                    type="text"
                    value={addDoctor?.country}
                    name="country"
                    placeHolder="Country"
                    handleChange={(e) =>
                      setAddDoctor(handleFormInput(e, addDoctor))
                    }
                    showIcon={false}
                    labelName="Country"
                    disabled={true}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <Input
                    className="border-radius_input"
                    type="text"
                    value={addDoctor?.city}
                    name="city"
                    placeHolder="city"
                    handleChange={(e) =>
                      setAddDoctor(handleFormInput(e, addDoctor))
                    }
                    showIcon={false}
                    labelName="City"
                    disabled={true}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <label htmlFor="mobile_number">{t("Mobile Number")} <span className="text-danger">*</span></label>
                  <div
                    className={`d-flex align-items-center border border-radius_input ps-2  ${isNewDoctor ? "userdisabled" : ""} ${i18n.language === "ar" ? "flex-row-reverse " : ""
                      }`}
                  >
                    {selectedCountry?.logo && (
                      <img

                        src={`${API_URL?.ServerURL}${selectedCountry?.logo?.startsWith("/") ? "" : "/"
                          }${selectedCountry?.logo}`}
                        alt="flag"
                        width="18"
                        height="15"
                        style={{ objectFit: "cover", marginRight: "8px" }}
                      />
                    )}

                    <span className="" style={{ minWidth: "42px" }}>
                      {selectedCountry?.code || "+966"}
                    </span>

                    <NumberInput
                      type="number"
                      className={`adddoctornumberinput ${isNewDoctor ? "bg-light " : ""}  ${i18n.language === "ar" ? "addmobilenumber" : ""}`}
                      name="mobileNo"
                      value={addDoctor.mobileNo}
                      handleChange={(e) =>
                        handlePhoneChange(selectedCountry?.code, e.target.value)
                      }
                      disabled={isNewDoctor}
                      showAsterisk={false}
                      placeholder="Enter mobile number"
                    />
                  </div>

                  <ErrorMsg error={formError?.mobileNo} />
                </div>
                {isPasswordFieldShow && doctorType !== "view" && (
                  <div className="col-12 col-md-6">
                    <Input
                      className="border-radius_input"
                      type={isPwdVisible}
                      value={addDoctor?.password}
                      name="password"
                      labelName="Password"
                      placeHolder="Enter your password"
                      disabled={isNewDoctor}
                      handleChange={(e) =>
                        setAddDoctor(
                          handleFormInput(e, addDoctor, formError, setFormError)
                        )
                      }
                      error={formError?.password}
                      showRightIcon={true}
                      rightIconSrc={
                        isPwdVisible === "password" ? EYE_CLOSE : EYE_OPEN
                      }
                      onRightIconClick={() =>
                        setIsPwdVisible(
                          isPwdVisible === "password" ? "text" : "password"
                        )
                      }
                    />
                    {formError?.password && (
                      <ErrorMsg error={formError?.password} />
                    )}
                  </div>
                )}
                <div className="col-md-6 mb-2">
                  <Input
                    className="border-radius_input"
                    type="number"
                    value={addDoctor?.experience}
                    name="experience"
                    placeHolder="Experience"
                    handleChange={(e) =>
                      setAddDoctor(handleFormInput(e, addDoctor))
                    }
                    showIcon={false}
                    labelName="Experience"
                    disabled={isNewDoctor}
                  />
                </div>

                <div className="col-md-6 mb-2">
                  {selectedOtherSpecialty ? (
                    <Input
                      type="text"
                      className="form-control border-radius_input"
                      placeholder="Enter Your Specialization"
                      labelName="Your Specialization"
                      name="specialization"
                      value={addDoctor.specialization || ""}
                      onChange={(e) =>
                        setAddDoctor({ ...addDoctor, specialization: e.target.value })
                      }
                      showastrict={true}
                      disabled={isNewDoctor}
                    />
                  ) : (
                    <DropDown
                      labelName="Specialization"
                      className="border-radius_input"
                      name="specialization"
                      options={[...specializationList, { label: "Other", value: "other" }]}
                      value={addDoctor.specialization}
                      handleSelect={(e) => {
                        const value = e.target.value;
                        if (value === "other") {
                          setSelectedOtherSpecialty(true);
                          setAddDoctor({ ...addDoctor, specialization: "" });
                        } else {
                          setSelectedOtherSpecialty(false);
                          setAddDoctor({ ...addDoctor, specialization: value });
                        }
                      }}
                      showastrict={true}
                      disabled={isNewDoctor}
                    />
                  )}
                </div>

                <div className="col-md-6 mb-2">
                  {selectedOtherProfile ? (
                    <Input
                      type="text"
                      className="form-control border-radius_input"
                      placeholder="Enter Your Profile"
                      labelName="Your Profile"
                      name="profile"
                      value={addDoctor.profile || ""}
                      onChange={(e) =>
                        setAddDoctor({ ...addDoctor, profile: e.target.value })
                      }
                      showastrict={true}
                      disabled={isNewDoctor}
                    />
                  ) : (
                    <DropDown
                      labelName="Profile"
                      className="border-radius_input"
                      name="profile"
                      options={[...profileList, { label: "Other", value: "other" }]}
                      value={addDoctor.profile}
                      handleSelect={(e) => {
                        const value = e.target.value;
                        if (value === "other") {
                          setSelectedOtherProfile(true);
                          setAddDoctor({ ...addDoctor, profile: "" });
                        } else {
                          setSelectedOtherProfile(false);
                          setAddDoctor({ ...addDoctor, profile: value });
                        }
                      }}
                      showastrict={true}
                      disabled={isNewDoctor}
                    />
                  )}
                </div>


                <div className="col-md-6 mb-2">
                  <DropDown
                    className="border-radius_input"
                    labelName="Select Gender"
                    name="gender"
                    options={genderList}
                    value={addDoctor?.gender}
                    handleSelect={(e) =>
                      setAddDoctor(handleFormInput(e, addDoctor))
                    }
                    showastrict={true}
                    disabled={isNewDoctor}
                  />
                  <ErrorMsg error={formError?.gender} />
                </div>
                <div className="col-md-12 my-3">
                  <div className="card  border border-radius_input ">
                    <div className="p-3 text-start">
                      <h3 className="fw-600 fs-16">{t("Fees Detail")}</h3>

                      <div className="row ">
                        <div className="col-md-3 mb-2">

                          <Input
                            placeHolder={`Enter Fees (${currencySign})`}
                            className="border-radius_input"
                            type="number"
                            value={addDoctor?.clinicFees}
                            name="clinicFees"
                            handleChange={(e) =>
                              setAddDoctor(
                                handleFormInput(e, addDoctor, formError, setFormError)
                              )
                            }
                            labelName="Fees"
                            showAsterisk={true}
                            onKeyDown={(e) => {
                              if (
                                [
                                  "e",
                                  "E",
                                  "+",
                                  "-",
                                  ".",
                                  "ArrowUp",
                                  "ArrowDown",
                                ].includes(e.key)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                        {/* Admin Share - Disabled */}
                        <div className="col-md-3 mb-2">
                          <Input
                            type="number"
                            value={adminShare}
                            name="adminShare"
                            labelName="Admin Share %"
                            disabled
                          />
                        </div>

                        {/* Clinic Share - Editable */}
                        <div className="col-md-3 mb-2">
                          <Input
                            type="number"
                            value={addDoctor?.clinicShare}
                            name="clinicShare"
                            labelName={`Clinic Share % (Max ${remainingShare}%)`}
                            handleChange={(e) => {
                              const inputValue = e.target.value;

                              if (inputValue === "") {
                                setAddDoctor((prev) => ({
                                  ...prev,
                                  clinicShare: "",
                                  doctorShare: "",
                                }));
                                return;
                              }

                              const value = Number(inputValue);

                              if (value < 0) return;

                              if (value > remainingShare) {
                                toastEmitter(
                                  "error",
                                  `Clinic share cannot exceed ${remainingShare}%`
                                );
                                return;
                              }

                              setAddDoctor((prev) => ({
                                ...prev,
                                clinicShare: value,
                                doctorShare: remainingShare - value,
                              }));
                            }}
                          />
                        </div>

                        {/* Doctor Share - Auto */}
                        <div className="col-md-3 mb-2">
                          <Input
                            type="number"
                            value={addDoctor?.doctorShare}
                            name="doctorShare"
                            labelName="Doctor Share %"
                            readOnly
                          />
                        </div>

                      </div>


                    </div>

                  </div>
                </div>

              </>
            )}
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-center ">
          {verifiedEmail ? (
            <>
              <Button
                type="button"
                className={`px-5 py-2 rounded border-0  me-sm-2 me-0 mb-sm-0 mb-2 cancelbtn ${i18n.language === "ar" ? "ms-3" : ""}`}
                label="Cancel"
                onClick={() => navigate(ROUTES.DOCTOR)}
              />

              {doctorType !== "view" && (
                <Button
                  disabled={!addDoctor}
                  type="submit"
                  className="px-5 py-2 rounded border-0 text-white submitbtn"
                  label="Add Doctor"
                  isLoading={isLoading}
                />
              )}
            </>
          ) : (
            <Button
              onClick={getDoctorbyEmail}
              type="submit"
              className="px-5 py-2 rounded border-0 text-white submitbtn"
              label={"Verified Email"}
              isLoading={isLoading}
            />
          )}
        </div>
      </form>

      <Modal
        modalId="adddoctor"
        modalClick={addbuttonClick}
        heading={t(modalContent?.heading)}
        paragraphclassName={t(modalContent?.paragraphclassName)}
        paragraph={t(modalContent?.paragraph)}
        handleModalClose={handleModalClose}

      />
    </div>
  );
};

export default AddDoctor;

